import type { Order } from "@jti/magento";

export const checkIsOrderContainNonTradeInItems = (order?: Order) => {
  if (!order?.items || order.items.length === 0) {
    return false;
  }

  return order.items.some((item) => !item.tradeIn);
};
